import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the Item type
interface Item {
  id: number;
  name: string;
  description: string;
}

// Define the Slice state type
interface ItemsState {
  items: Item[];
}

const initialState: ItemsState = {
  items: [],
};

const itemSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    // Create an item
    addItem: (state, action: PayloadAction<Item>) => {
      state.items.push(action.payload);
    },
   
    // Update an item
    updateItem: (state, action: PayloadAction<Item>) => {
      const index = state.items.findIndex((item) => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    // Delete an item
    deleteItem: (state, action: PayloadAction<number>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
    },
    // Set fetched items
    setItems: (state, action) => {
      state.items = action.payload; 
    },
  },
});

// Export actions and reducer
export const { addItem, updateItem, deleteItem, setItems } = itemSlice.actions;
export default itemSlice.reducer;
